import { ConfigProvider } from 'antd';
import enUS from 'antd/es/locale/en_US';
import jaJP from 'antd/es/locale/ja_JP';
import zhCN from 'antd/es/locale/zh_CN';
import type { Locale } from 'antd/es/locale';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import router from '@/router';
import { useDesignScale } from '@/hooks/useDesignScale';
import i18n, { type SupportedLanguage } from '@/locales';

const antdLocales: Record<SupportedLanguage, Locale> = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'ja-JP': jaJP,
};

function AppContent() {
  const scale = useDesignScale();
  const { i18n: currentI18n } = useTranslation();
  const language = (currentI18n.resolvedLanguage ?? currentI18n.language) as SupportedLanguage;

  return (
    <ConfigProvider
      locale={antdLocales[language] ?? zhCN}
      theme={{
        token: {
          colorPrimary: '#1677ff',
          fontSize: 14 * scale,
          controlHeight: 32 * scale,
          borderRadius: 10 * scale,
          sizeUnit: 4 * scale,
          sizeStep: 4 * scale,
          fontFamily: 'var(--font-family-current)',
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AppContent />
    </I18nextProvider>
  );
}
